import { useEffect, useState } from 'react';

/** Folgt einer Medienabfrage (`(min-width: 640px)`); ohne `matchMedia` (Server, alte Umgebungen) gilt `fallback`. */
export function useMediaQuery(query: string, fallback = true): boolean {
  const read = () =>
    typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback;
  const [matches, setMatches] = useState(read);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const list = window.matchMedia(query);
    const onChange = () => setMatches(list.matches);
    onChange();
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Ab dieser Breite gilt die obere Leiste (Desktop und Tablet); darunter die untere (Handy). */
export const TOP_BAR_QUERY = '(min-width: 640px)';
